import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Http from "../../../http";
import ShippingModal from "./shipping-modal";
import EntryStatus from "../../atoms/entry-status";
import EntryManagementStatusComponent from "../../atoms/entry-management-status";
import IrregularStatus from "../../atoms/irregular-status";
import EntryManagementStatus from "../../../constants/entry-management-status";
import ENTRY_STATUS from "../../../constants/entry-status";
import { FormatUtil, MemoModal, ConfirmModal, Spinner } from "@graffer-inc/graffer-ui";
import Transition from "../../../utils/transition";
import File from "../../../utils/file";
import Char from "../../../utils/char";
import CONST from "../../../constants";
import printJS from 'print-js'
import APPLICATION_TYPE from "../../../constants/application-type";
import IRREGULAR_STATUS from "../../../constants/irregular-status";
import moment from 'moment';

const Main = ({ match }) => {
  const [entryInfo, setEntryInfo] = useState(null);
  const [registryOfficeInfo, setRegistryOfficeInfo] = useState({
    postalCode: '',
    address: '',
    name: '',
  });
  const [onPrintShippingAddress, setOnPrintShippingAddress] = useState(false);
  const [onPrintDeliveryShippingAddress, setOnPrintDeliveryShippingAddress] = useState(false);
  const [isMemoModalOpening, setIsMemoModalOpening] = useState(false);
  const [isRefundModalOpening, setIsRefundModalOpening] = useState(false);
  const [isShippingModalOpening, setIsShippingModalOpening] = useState(false);
  const [isApplyReadyChangeModalOpening, setIsApplyReadyChangeModalOpening] = useState(false);
  const [isModalReturningToEnterSerialNoOpening, setModalReturningToEnterSerialNoOpening] = useState(false);
  const [isModalReturningToGenerateReadyOpening, setModalReturningToGenerateReadyOpening] = useState(false);
  const [isDownloadAvailableModalOpening, setIsDownloadAvailableModalOpening] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAllEntry = async () => {
    setIsLoading(true);
    await Http.fetchAllEntry(
      match.params.entryId,
      async (res) => {
        if (!res.data.registryOffice) {
          toast.error("登記所の取得に失敗しました。申し込み法人の本店所在地を確認してください。");
          setRegistryOfficeInfo({
            postalCode: '',
            address: '',
            name: '',
          });
        } else {
          await Http.searchAddressOnGoogleMap(
            res.data.registryOffice.name + res.data.registryOffice.branch,
            res2 => {
              const formattedAddress = res2.data.candidates[0].formatted_address;
              const postalCodeAndAddress = formattedAddress.split('〒')[1].split(' ');
              const postalCode = postalCodeAndAddress[0];
              postalCodeAndAddress.shift();
              const address = postalCodeAndAddress.reduce((acc, value) => acc + ' ' + value);
              setRegistryOfficeInfo({
                postalCode: postalCode,
                address: address,
                name: res.data.registryOffice.name + res.data.registryOffice.branch,
              });
            },
            () => {
              setRegistryOfficeInfo({
                postalCode: '',
                address: '',
                name: res.data.registryOffice.name + res.data.registryOffice.branch,
              });
            }
          );
        }
        setEntryInfo(res.data);
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('申込詳細の取得に失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
    setIsLoading(false);
  };

  const refund = async () => {
    await Http.refund(
      match.params.entryId,
      { versionNo: entryInfo ? entryInfo.entry.versionNo : 1 },
      () => {
        toast.success('返金しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const changeStatusToDownloadAvailable = async () => {
    await Http.changeStatusToDownloadAvailable(
      match.params.entryId,
      { versionNo: entryInfo ? entryInfo.entry.versionNo : 1 },
      () => {
        toast.success('ステータスを未ダウンロードに戻しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else if (err.response.status < 500) {
          toast.error(err.response.data.msg);
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const changeStatusToApplyReady = async () => {
    await Http.changeStatusToApplyReady(
      entryInfo.entryManagement.id,
      { versionNo: entryInfo ? entryInfo.entryManagement.versionNo : 1 },
      () => {
        toast.success('ステータスを申請前に戻しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else if (err.response.status < 500) {
          toast.error(err.response.data.msg);
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const changeStatusEnteringSerialNo = async () => {
    await Http.changeStatusEnteringSerialNo(
      entryInfo.entryManagement.id,
      { versionNo: entryInfo ? entryInfo.entryManagement.versionNo : 1 },
      () => {
        toast.success('ステータスをシリアル番号入力状態に戻しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else if (err.response.status < 500) {
          toast.error(err.response.data.msg);
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const changeStatus = async (status) => {
    await Http.updateEntryManagementStatus(
      entryInfo.entryManagement.id,
      { versionNo: entryInfo ? entryInfo.entryManagement.versionNo : 1, status },
      () => {
        toast.success('ステータスを戻しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else if (err.response.status < 500) {
          toast.error(err.response.data.msg);
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const changeIrregularStatus = async (status) => {
    setIsLoading(true);
    await Http.changeIrregularStatus(
      entryInfo.entryManagement.id,
      { irregularStatus: status, versionNo: entryInfo ? entryInfo.entryManagement.versionNo : 1 },
      () => {
        toast.success('イレギュラーステータスを変更しました。');
        fetchAllEntry();
      },
      (err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else if (err.response.status < 500) {
          toast.error(err.response.data.msg);
        } else {
          toast.error('失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const downloadSHINSEI = async () => {
    await Http.fetchSHINSEI(
      match.params.entryId,
      (res) => {
        try {
          File.download(window.atob(res.data.encoded), 'SHINSEI', 'application/octet-stream', true);
        } catch (e) {
          console.error(e);
        }
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('SHINSEIファイルのダウンロードに失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const createApplicationPDFRequestBody = () => {
    const periodInfo = CONST.MASTER.CERT_PERIOD.find(p => p.period === Number(entryInfo.entry.certPeriod));
    const dataBase = {
      registryOffice: entryInfo.registryOffice.name === '東京法務局' ? '' : entryInfo.registryOffice.name.replace('法務局', ''), // "法務局名"
      registryOfficeBranch: entryInfo.registryOffice.branch ? entryInfo.registryOffice.branch.replace('支局', '').replace('出張所', '').replace('本局', '') : "", // 支局・出張所（経由） 名
      corporateNumber: FormatUtil.corporateNumber(entryInfo.entry.corporateId), // 会社法人等番号
      corporateName: entryInfo.entry.corporateName, // 商号（名称）
      corporateAddress: entryInfo.corporateAddressSetByUser ? entryInfo.corporateAddressSetByUser.value : entryInfo.entry.corporateAddress || '', // 本店（事務所）
      stampSubmitterQualification: entryInfo.stampSubmitter.qualification, // 印鑑提出者 | 資格
      stampSubmitterName: entryInfo.stampSubmitter.name, // 印鑑提出者 | 名前
      stampSubmitterBirthWareki: entryInfo.stampSubmitter.typeOfCalendar === '西暦' ? '' : entryInfo.warekiBirthday.wareki, // 印鑑提出者｜生年月日和暦
      stampSubmitterBirthYear: entryInfo.stampSubmitter.typeOfCalendar === '西暦' ? moment(entryInfo.stampSubmitter.birthday).year().toString() : entryInfo.warekiBirthday.year.toString(), // 印鑑提出者｜生年月日：年
      stampSubmitterBirthMonth: entryInfo.warekiBirthday.month.toString(), // 印鑑提出者｜生年月日：月
      stampSubmitterBirthDate: entryInfo.warekiBirthday.day.toString(), // 印鑑提出者｜生年月日：日
      certPeriod: periodInfo ? Char.toZenkaku(periodInfo.period.toString()) : '', // 証明期間
      price: periodInfo ? periodInfo.price.toString() : '', // 手数料
      stampSubmitterName2: entryInfo.stampSubmitter.name, // 申請人 氏名
    };
    const dataAttorneyAddonInfo = {
      stampSubmitterName2: '', // 申請人 氏名
      attorneyAddress: entryInfo.entry.attorneyAddress || '', // 代理人 住所
      attorneyName: entryInfo.entry.attorneyName || '', // 代理人 氏名
      attorneyCertPeriod: periodInfo.period.toString().toUpperCase(), // 証明期間(委任の場合のみ)
      attorneyCorporateName: entryInfo.entry.corporateName, // 委任状 商号（名称）
      attorneyCorporateAddress: entryInfo.entry.corporateAddress || '', // 委任状 本店（事務所）
      attorneyQualificationAndName: `${entryInfo.stampSubmitter.qualification} ${entryInfo.stampSubmitter.name}`, // 委任状 資格・氏名
    };

    const data = entryInfo.entry.attorneyName && entryInfo.entry.attorneyAddress ? Object.assign(dataBase, dataAttorneyAddonInfo) : dataBase;
    return data;
  }

  const printApplicationForm = async () => {
    const body = createApplicationPDFRequestBody();
    await Http.createApplicationPdf(
      match.params.entryId,
      body,
      (res) => {
        try {
          printJS({ printable: res.data.encoded, type: "pdf", base64: true });
        } catch (e) {
          console.error(e);
        }
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('申請書のダウンロードに失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const downloadForm = async () => {
    const body = createApplicationPDFRequestBody();
    await Http.createApplicationPdf(
      match.params.entryId,
      body,
      (res) => {
        try {
          File.download(res.data.encoded, `申請書_${match.params.entryId}.pdf`, 'application/pdf', true);
        } catch (e) {
          console.error(e);
        }
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('申請書のダウンロードに失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const ship = async (trackingNo) => {
    await Http.ship(
      match.params.entryId,
      { versionNo: entryInfo ? entryInfo.entry.versionNo : 1, trackingNo },
      () => {
        toast.success('発送完了通知メールを送信しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('発送完了通知メールの送信に失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  const updateMemo = async (memo) => {
    await Http.updateMemo(
      entryInfo ? entryInfo.entryManagement.id : '',
      {
        memo,
        versionNo: entryInfo ? entryInfo.entryManagement.versionNo : 1
      },
      () => {
        toast.success('メモを更新しました。');
        fetchAllEntry();
      },
      (err) => {
        if ([401, 403].includes(err.response.status)) {
          Transition.goToEmsLogin();
        } else {
          toast.error('メモの編集に失敗しました。画面をリロードまたは再ログインしてください。');
        }
      }
    );
  };

  useEffect(() => {
    fetchAllEntry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (onPrintShippingAddress) {
      printJS({ printable: 'print-shipping-info', type: 'html', targetStyles: ['*'] });
      setOnPrintShippingAddress(false);
    }
    if (onPrintDeliveryShippingAddress) {
      printJS({ printable: 'print-delivery-shipping-info', type: 'html', targetStyles: ['*'] });
      setOnPrintDeliveryShippingAddress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onPrintDeliveryShippingAddress, onPrintShippingAddress, setOnPrintShippingAddress, setOnPrintDeliveryShippingAddress]);
  return (
    <div>
      <p className="is-size-3 has-text-weight-bold">電子証明書取得サポート - 申込詳細</p>
      <br />
      {
        entryInfo && !isLoading ? (
          <div className="card margin-bottom-10">
            <header className="card-header">
              <p className="card-header-title is-size-7">
                <span>{entryInfo.entry.id}</span>
              </p>
            </header>
            <div className="card-content">
              <div style={{ padding: '0px 0px 10px' }}>
                <p style={{ paddingBottom: '10px' }}>
                  <span className="is-size-7 has-text-weight-bold" style={{ paddingRight: '5px' }}>
                    ユーザー注文情報
                  </span>
                  <span style={{ paddingRight: '10px' }}>
                    <EntryStatus status={entryInfo.entry.status} desktopFontSize="is-size-7" isRefunded={entryInfo.entry.isRefunded} />
                  </span>
                  {
                    !entryInfo.entry.isRefunded && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setIsRefundModalOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>返金する</a>
                      </span>
                    )
                  }
                  {
                    entryInfo.entry.status === ENTRY_STATUS.CODE.DOWNLOADED && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setIsDownloadAvailableModalOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>未ダウンロードに戻す</a>
                      </span>
                    )
                  }
                </p>
                <div className="box">
                  <div className="columns is-size-7 content">
                    <div className="column">
                      <div><p className="has-text-weight-bold">注文詳細</p>
                        <table className="table unhoverable">
                          <tbody>
                            <tr>
                              <td>注文者ID / 注文者名</td>
                              <td>{entryInfo.entry.userId}<br />{entryInfo.entry.userName}</td>
                            </tr>
                            <tr>
                              <td>法人名</td>
                              <td><p>{entryInfo.entry.corporateName}</p></td>
                            </tr>
                            <tr>
                              <td>電子証明書の証明期間</td>
                              <td>{entryInfo.entry.certPeriod}ヵ月</td>
                            </tr>
                            <tr>
                              <td>申請者</td>
                              <td>{!entryInfo.entry.attorneyName && !entryInfo.entry.attorneyAddress ? '印鑑提出者本人' : (<p>
                                <span>代理人</span>
                                <br />
                                {entryInfo.entry.attorneyAddress}
                                <br />
                                {entryInfo.entry.attorneyName}
                              </p>)}</td>
                            </tr>
                            <tr>
                              <td>申請プラン</td>
                              <td>{APPLICATION_TYPE.name(entryInfo.entry.applicationType)}プラン</td>
                            </tr>
                            <tr>
                              <td>発行手数料分の収入印紙</td>
                              <td>{entryInfo.entry.isWithRevenueStamp ? `セットでつける(${FormatUtil.price(CONST.MASTER.CERT_PERIOD.find(p => p.period === entryInfo.entry.certPeriod).price)}円)` : 'セットでつけない'}</td>
                            </tr>
                            <tr>
                              <td>電子証明書のアカウント登録</td>
                              <td>{entryInfo.entry.isRegistryCertsRegistration ? '登録する' : '登録しない'}</td>
                            </tr>
                            <tr>
                              <td>合計金額(税込)</td>
                              <td>{FormatUtil.price(entryInfo.entry.amount)}円</td>
                            </tr>
                            <tr>
                              <td>お届け先</td>
                              <td>{entryInfo.shippingAddress.postalCode} {entryInfo.shippingAddress.address}<br />{entryInfo.shippingAddress.receiverName}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ padding: '10px 0px' }}>
                <p style={{ paddingBottom: '10px' }}>
                  <span className="is-size-7 has-text-weight-bold" style={{ paddingRight: '5px' }}>管理情報</span>
                  <span style={{ paddingRight: '10px' }}>
                    <EntryManagementStatusComponent status={entryInfo.entryManagement.status} desktopFontSize="is-size-7" />
                  </span>
                  <span>
                    <span> / </span>
                    {/* eslint-disable-next-line */}
                    <a onClick={printApplicationForm} className="is-size-7" style={{ padding: '0px 5px' }}>申請書を印刷する</a>
                  </span>
                  <span>
                    <span> / </span>
                    {/* eslint-disable-next-line */}
                    <a onClick={downloadForm} className="is-size-7" style={{ padding: '0px 5px' }}>申請書をダウンロード</a>
                  </span>
                  <span>
                    <span> / </span>
                    {/* eslint-disable-next-line */}
                    <a onClick={() => setOnPrintShippingAddress(true)} className="is-size-7" style={{ padding: '0px 5px' }}>送付情報を印刷する</a>
                  </span>
                  {
                    entryInfo.entry.applicationType === APPLICATION_TYPE.CODE.DELIVERY && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setOnPrintDeliveryShippingAddress(true)} className="is-size-7" style={{ padding: '0px 5px' }}>郵送申請の郵送情報を印刷する</a>
                      </span>
                    )
                  }
                  {
                    entryInfo.entryManagement.status !== EntryManagementStatus.CODE.APPLY_READY && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={downloadSHINSEI} className="is-size-7" style={{ padding: '0px 5px' }}>SHINSEIダウンロード</a>
                      </span>
                    )
                  }
                  {
                    !entryInfo.entry.isRefunded && entryInfo.entryManagement.status === EntryManagementStatus.CODE.APPLIED && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setIsShippingModalOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>発送完了メールを送る</a>
                      </span>
                    )
                  }
                  {
                    !entryInfo.entry.isRefunded && [EntryManagementStatus.CODE.APPLY_FAILED, EntryManagementStatus.CODE.APPLIED].includes(entryInfo.entryManagement.status) && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setIsApplyReadyChangeModalOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>申請前に戻す</a>
                      </span>
                    )
                  }
                  {
                    !entryInfo.entry.isRefunded && [EntryManagementStatus.CODE.GENERATE_READY, EntryManagementStatus.CODE.GENERATE_FAILED, EntryManagementStatus.CODE.GENERATED].includes(entryInfo.entryManagement.status) && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setModalReturningToEnterSerialNoOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>シリアル番号入力に戻す</a>
                      </span>
                    )
                  }
                  {
                    !entryInfo.entry.isRefunded && [EntryManagementStatus.CODE.GENERATE_FAILED].includes(entryInfo.entryManagement.status) && (
                      <span>
                        <span> / </span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setModalReturningToGenerateReadyOpening(true)} className="is-size-7" style={{ padding: '0px 5px' }}>電子証明書発行前に戻す</a>
                      </span>
                    )
                  }
                </p>
                <div className="box">
                  <div className="columns is-size-7 content">
                    <div className="column">
                      <p>
                        <span className="has-text-weight-bold" style={{ padding: '0 3px 0 0' }}>イレギュラー</span>
                        <IrregularStatus status={entryInfo.entryManagement.irregularStatus} desktopFontSize="is-size-7" />
                        {
                          entryInfo.entryManagement.irregularStatus !== IRREGULAR_STATUS.CODE.REQUIRE && (
                            <>
                              <span style={{ padding: '0 5px' }}>
                                /
                              </span>
                              {/* eslint-disable-next-line */}
                              <a onClick={async () => await changeIrregularStatus(IRREGULAR_STATUS.CODE.REQUIRE)}>要対応に変更する</a>
                            </>
                          )
                        }
                        {
                          entryInfo.entryManagement.irregularStatus !== IRREGULAR_STATUS.CODE.WAIT && (
                            <>
                              <span style={{ padding: '0 5px' }}>
                                /
                              </span>
                              {/* eslint-disable-next-line */}
                              <a onClick={async () => await changeIrregularStatus(IRREGULAR_STATUS.CODE.WAIT)}>お客様待ちに変更する</a>
                            </>
                          )
                        }
                        {
                          entryInfo.entryManagement.irregularStatus !== IRREGULAR_STATUS.CODE.NONE && (
                            <>
                              <span style={{ padding: '0 5px' }}>
                                /
                              </span>
                              {/* eslint-disable-next-line */}
                              <a onClick={async () => await changeIrregularStatus(IRREGULAR_STATUS.CODE.NONE)}>なしに戻す</a>
                            </>
                          )
                        }
                      </p>
                    </div>
                  </div>
                  <div className="columns is-size-7 content">
                    <div className="column">
                      <p>
                        <span className="has-text-weight-bold">メモ</span>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => setIsMemoModalOpening(true)} style={{ padding: '0 0 0 5px' }}>編集する</a>
                      </p>
                      <pre>{entryInfo.entryManagement.memo}</pre>
                    </div>
                  </div>
                  <div className="columns is-size-7 content">
                    <div className="column">
                      <p>
                        <span className="has-text-weight-bold">追跡番号</span>
                        {
                          entryInfo.entryManagement.trackingNo && (
                            <a href={`https://trackings.post.japanpost.jp/services/sp/srv/search/?search=開始&locale=ja&requestNo1=${entryInfo.entryManagement.trackingNo}`} target="_blank" rel="noopener noreferrer" style={{ padding: '0 0 0 5px' }}>配送状況を確認する</a>
                          )
                        }
                      </p>
                      <pre>{entryInfo.entryManagement.trackingNo}</pre>
                    </div>
                  </div>
                  <div className="columns is-size-7 content">
                    <div className="column">
                      <p className="has-text-weight-bold">失敗理由</p>
                      <pre>{entryInfo.entryManagement.failReason}</pre>
                    </div>
                  </div>
                </div>
              </div>
              <p className="has-text-right is-size-7 has-text-grey">
                <span>申込日時: {FormatUtil.dateWithTime(entryInfo.entry.createdAt)}</span>
              </p>
            </div>
            <div id="print-shipping-info">
              {
                onPrintShippingAddress && (
                  <>
                    <table className="table c-shipping-address-table">
                      <tbody>
                        <tr>
                          <td>{FormatUtil.postalCode(entryInfo.shippingAddress.postalCode)}</td>
                        </tr>
                        <tr>
                          <td>
                            {entryInfo.shippingAddress.address}
                          </td>
                        </tr>
                        <tr>
                          <td>{entryInfo.shippingAddress.receiverName}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table c-shipping-address-table">
                      <tbody>
                        <tr>
                          <td>151-0051</td>
                        </tr>
                        <tr>
                          <td>
                            東京都渋谷区千駄ケ谷1-5−8 ジュニアビル2F
                          </td>
                        </tr>
                        <tr>
                          <td>株式会社グラファー</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )
              }
            </div>
            <div id="print-delivery-shipping-info">
              {
                onPrintDeliveryShippingAddress && (
                  <>
                    <table className="table c-shipping-address-table">
                      <tbody>
                        <tr>
                          <td><span>{registryOfficeInfo.postalCode}</span><span className="has-text-weight-bold is-size-5" style={{ paddingLeft: '220px' }}>[申請用]</span></td>
                        </tr>
                        <tr>
                          <td>
                            {registryOfficeInfo.address}
                          </td>
                        </tr>
                        <tr>
                          <td>{registryOfficeInfo.name}<br />電子証明書発行担当</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table c-shipping-address-table">
                      <tbody>
                        <tr>
                          <td>{FormatUtil.postalCode(entryInfo.shippingAddress.postalCode)}</td>
                        </tr>
                        <tr>
                          <td>
                            {entryInfo.shippingAddress.address}
                          </td>
                        </tr>
                        <tr>
                          <td>{entryInfo.shippingAddress.receiverName}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table c-shipping-address-table">
                      <tbody>
                        <tr>
                          <td>{FormatUtil.postalCode(entryInfo.shippingAddress.postalCode)}<span className="has-text-weight-bold is-size-5" style={{ paddingLeft: '220px' }}>[返信用]</span></td>
                        </tr>
                        <tr>
                          <td>
                            {entryInfo.shippingAddress.address}
                          </td>
                        </tr>
                        <tr>
                          <td>{entryInfo.shippingAddress.receiverName}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )
              }
            </div>
          </div>
        ) : (<div style={{ padding: '100px 0' }} className="has-text-centered"><Spinner /></div>)
      }
      {isMemoModalOpening && <MemoModal
        initialValue={entryInfo.entryManagement.memo}
        onClose={() => setIsMemoModalOpening(false)}
        onEdit={async (v) => {
          await updateMemo(v);
          setIsMemoModalOpening(false);
        }}
      />}
      {isRefundModalOpening && <ConfirmModal
        confirmMessage="こちらの申込を返金します。よろしいですか？"
        executeLabel="返金する"
        onClose={() => setIsRefundModalOpening(false)}
        onExecute={async () => {
          await refund();
          setIsRefundModalOpening(false);
        }}
      />}
      {isDownloadAvailableModalOpening && <ConfirmModal
        confirmMessage="こちらの申込のステータスを未ダウンロードに戻します。よろしいですか？"
        executeLabel="未ダウンロードに戻す"
        onClose={() => setIsDownloadAvailableModalOpening(false)}
        onExecute={async () => {
          await changeStatusToDownloadAvailable();
          setIsDownloadAvailableModalOpening(false);
        }}
      />}
      {isShippingModalOpening && <ShippingModal
        onClose={() => setIsShippingModalOpening(false)}
        onExecute={async (trackingNo) => {
          await ship(trackingNo);
          setIsShippingModalOpening(false);
        }}
      />}
      {isApplyReadyChangeModalOpening && <ConfirmModal
        confirmMessage="こちらの申込のステータスを申請前に戻します。よろしいですか？"
        executeLabel="申請前に戻す"
        onClose={() => setIsApplyReadyChangeModalOpening(false)}
        onExecute={async () => {
          await changeStatusToApplyReady();
          setIsApplyReadyChangeModalOpening(false);
        }}
      />}
      {isModalReturningToEnterSerialNoOpening && <ConfirmModal
        confirmMessage="こちらの申込をシリアル番号入力が可能な状態に戻します。よろしいですか？"
        executeLabel="戻す"
        onClose={() => setModalReturningToEnterSerialNoOpening(false)}
        onExecute={async () => {
          await changeStatusEnteringSerialNo();
          setModalReturningToEnterSerialNoOpening(false);
        }}
      />}
      {isModalReturningToGenerateReadyOpening && <ConfirmModal
        confirmMessage="こちらの申込を電子証明書発行前に戻します。よろしいですか？"
        executeLabel="戻す"
        onClose={() => setModalReturningToGenerateReadyOpening(false)}
        onExecute={async () => {
          await changeStatus(EntryManagementStatus.CODE.GENERATE_READY);
          setModalReturningToGenerateReadyOpening(false);
        }}
      />}
    </div>
  )
};

export default Main;